module.exports = __webpack_public_path__ + "media/images/icons/icon-pound-orange-17edb02d85d328cff1f5a6235bdb82d8.svg";